/* global location */

import { Module } from 'wrapper6'
import ProductService from '../services/_product-service'
import MiniCart from './_mini_cart'

export default class AddToCart extends Module {
  ready () {
    this.form = document.getElementsByClassName('cart')[0]
    this.button = document.getElementsByName('add-to-cart')[0]
    this.quantity = document.getElementsByClassName('qty')[0]

    if (this.button) {
      this.button.addEventListener('click', async (e) => {
        this.addToCart(e, this.button.value, this.quantity.value)
      })
    }
  }

  async addToCart (e, productId, quantity) {
    e.preventDefault()

    this.button.classList.add('loading')
    const addToCart = await ProductService.addProductToCart(productId, quantity)

    if (addToCart.data.added) {
      MiniCart.updateCartContents(addToCart.data.html)
    } else {
      location.reload()
    }
    this.button.classList.remove('loading')
  }
}
